import type { DecisionEngineDestinationDefinition } from "./definition";
import { hightouchPayloadMapping } from "./sync-config-helpers";

export const klaviyoDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "klaviyo",
  category: "event",
  generateSyncConfig: ({ producer, scopeId, channelType, messageTags }) => ({
    type: "event",
    eventName: "hightouch_interaction",
    externalIdMapping: { from: "external_id", to: "email" },
    mappings: [],
    customMappings: [
      hightouchPayloadMapping({ producer, messageTags }),
      { type: "standard", from: "campaign_id", to: "message_identifier" },
      {
        type: "static",
        value: scopeId,
        valueType: "STRING",
        to: "agent_identifier",
      },
      {
        type: "static",
        value: channelType,
        valueType: "STRING",
        to: "channel",
      },
    ],
  }),
  syncStrategy: {
    supportsChannelLevelSync: false,
  },
};
